/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_Save_CurrentInputs */

const en_us2_gyms_save_current = /** @type {(inputs: Gyms_Save_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save current equipment as a gym`)
};

const pt_br2_gyms_save_current = /** @type {(inputs: Gyms_Save_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar equipamentos atuais como academia`)
};

const es_419_gyms_save_current = /** @type {(inputs: Gyms_Save_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar el equipo actual como gimnasio`)
};

const pt_pt2_gyms_save_current = /** @type {(inputs: Gyms_Save_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar o equipamento atual como ginásio`)
};

const fr_fr2_gyms_save_current = /** @type {(inputs: Gyms_Save_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer l'équipement actuel comme salle`)
};

const de_de2_gyms_save_current = /** @type {(inputs: Gyms_Save_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Ausstattung als Studio speichern`)
};

const it_it2_gyms_save_current = /** @type {(inputs: Gyms_Save_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva l'attrezzatura attuale come palestra`)
};

/**
* | output |
* | --- |
* | "Save current equipment as a gym" |
*
* @param {Gyms_Save_CurrentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_save_current = /** @type {((inputs?: Gyms_Save_CurrentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Save_CurrentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_save_current(inputs)
	if (locale === "es-419") return es_419_gyms_save_current(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_save_current(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_save_current(inputs)
	if (locale === "de-DE") return de_de2_gyms_save_current(inputs)
	if (locale === "it-IT") return it_it2_gyms_save_current(inputs)
	return en_us2_gyms_save_current(inputs)
});
export { gyms_save_current as "gyms.save_current" }